// src/components/pages/segment/SegmentListing.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSegments, createSegment } from "../../../../redux/actions/journeyAction";
import { Modal, Button, Form, Table } from "react-bootstrap";

const SegmentListing = ({ pageTypeHandler, authToken }) => {
  const dispatch = useDispatch();
  const { segments, loading, error } = useSelector((state) => state.segment || {});

  const [showCreate, setShowCreate] = useState(false);
  const [name, setName] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [segmentToDelete, setSegmentToDelete] = useState(null);

  useEffect(() => {
    pageTypeHandler && pageTypeHandler("Segment");
  }, [pageTypeHandler]);

  useEffect(() => {
    dispatch(fetchSegments(authToken));
  }, [dispatch, authToken]);

  const handleCreate = () => {
    if (!name.trim()) return;
    dispatch(createSegment(authToken, { title: name }));
    setName("");
    setShowCreate(false);
  };

  const confirmDelete = (seg) => {
    setSegmentToDelete(seg);
    setShowDelete(true);
  };



  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Segments</h3>
        <Button onClick={() => setShowCreate(true)}>+ New Segment</Button>
      </div>

      {loading && <div>Loading...</div>}
      {error && <div className="text-danger">{error}</div>}

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Segment Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {segments && segments.length ? (
            segments.map((s, idx) => (
              <tr key={s.id || idx}>
                <td>{idx + 1}</td>
                <td>{s.title || s.name}</td>
                <td>
                  <Button variant="outline-primary" size="sm" onClick={() => {/* navigate to edit page if you have */}}>
                    Edit
                  </Button>{" "}
                  <Button variant="outline-danger" size="sm" onClick={() => confirmDelete(s)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="text-center">No segments</td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Create modal */}
      <Modal show={showCreate} onHide={() => setShowCreate(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create Segment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Segment Name</Form.Label>
            <Form.Control value={name} onChange={(e) => setName(e.target.value)} placeholder="Segment name" />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreate(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleCreate}>Create</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default SegmentListing;
